function getFileExtension(mimeType: string): string {
  const mimeToExt: { [key: string]: string } = {
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    "application/pdf": "pdf",
    "text/plain": "txt",
    "text/csv": "csv",
    "application/json": "json",
    "application/zip": "zip",
  }

  return mimeToExt[mimeType] || "bin"
}

export function base64ToBlob(base64: string, type: string): Blob {
  const binary = atob(base64)
  const bytes = Uint8Array.from(binary, (char) => char.codePointAt(0) ?? 0)
  return new Blob([bytes], { type })
}

export function downloadFile(data: BlobPart, fileName: string, type: string) {
  const blob = new Blob([data], { type })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

// Long enough for the tab to load the blob before its URL is released.
const OPENED_BLOB_URL_LIFETIME_MS = 60_000

// The tab is opened by the caller during the click, before any slow fetch,
// so popup blockers don't stop it.
export function openBlobInTab(tab: Window, blob: Blob) {
  const url = window.URL.createObjectURL(blob)
  tab.location.href = url
  setTimeout(() => window.URL.revokeObjectURL(url), OPENED_BLOB_URL_LIFETIME_MS)
}

export async function downloadFromSignedUrl(
  signedUrl: string,
  fileName: string,
  mimeType: string,
) {
  try {
    const response = await fetch(signedUrl)

    if (!response.ok) {
      throw new Error(`Failed to download file: ${response.statusText}`)
    }

    const arrayBuffer = await response.arrayBuffer()

    const extension = getFileExtension(mimeType)
    const fileNameWithExt = fileName.includes(".")
      ? fileName
      : `${fileName}.${extension}`

    downloadFile(arrayBuffer, fileNameWithExt, mimeType)
  } catch (error) {
    throw Error(`Error downloading file: ${error}`)
  }
}
